<template>
  <div class="goods">
    <van-nav-bar title="爱车直卖" left-arrow @click-left="onClickLeft" style="height: 1.28rem"/>

    <!--<van-swipe class="goods-swipe" :autoplay="3000">
      <van-swipe-item v-for="thumb in goods.thumb" :key="thumb">
        <img :src="thumb" >
      </van-swipe-item>
    </van-swipe>-->
    <img src="../../image/banner2.png" alt="" style="width: 100%">

    <div style="border-top: .324rem solid #F2F2F2;">
      <div class="flex-start" style="height:1.28rem;font-size:0.459rem;color: #333;margin-left: .351rem;border-bottom: 1px solid #E9E9E9;font-weight: bold;">直卖小流程</div>
    </div>
    <div class="flex-start" style="padding: 0 .405rem;font-size: .351rem;color: #333;">
      <van-col span="6" v-for="(item,index) in goods.list" class="flex-column" style="height: 2.7rem;position: relative">
        <!--<van-icon v-bind:name="item.icon" style="font-size: .684rem;margin-bottom: .459rem"/>-->
        <img v-bind:src="item.icon" alt="" style="width: 0.667rem;margin-bottom: .5rem;">
        <div>
          {{item.name}}
          <van-icon v-if="index !=3" name="arrow" style="position: absolute;right: -.18rem;top: .8rem;font-size: .351rem;"/>
        </div>
      </van-col>
    </div>
    <div class="flex-center" style="margin: 0 .405rem .54rem;font-size: .351rem;color: #07B2EA;height: 1.188rem;background: #F6FAFF;border-radius: .27rem;" @click="onClickCars">如果您觉得麻烦，想直接卖车给4S店，请点击>></div>

    <div style="border-top: .324rem solid #F2F2F2;">
      <div class="flex-start" style="height:1.28rem;font-size:0.459rem;color: #333;margin-left: .351rem;border-bottom: 1px solid #E9E9E9;font-weight: bold;">直卖小知识</div>
    </div>
    <div style="padding: .432rem .81rem 0 .945rem;font-size: .351rem;color: #999;line-height: .54rem;">
      <div style="position: relative;margin-bottom: .702rem;">
        <img src="../../image/index6.png" alt="" style="position: absolute;left: -0.65rem;width: .5335rem;">
        <!--<van-icon name="fire-o" style="font-size: .432rem;position: absolute;left: -.5rem;"/>-->
        <div>
          <div style="font-size: .432rem;color: #333;margin-bottom: .54rem;">什么是爱车直卖？</div>
          <div>爱车直卖是直接面向二手车买卖家的交易服务模式，省去了中间环节（中介、车商等），以互联网连接买家到 卖家，给买卖双方更多利益空间</div>
        </div>
      </div>

      <div style="position: relative;margin-bottom: .702rem;">
        <img src="../../image/index6.png" alt="" style="position: absolute;left: -0.65rem;width: .5335rem;">
        <div>
          <div style="font-size: .432rem;color: #333;margin-bottom: .54rem;">爱车直卖有什么好处？</div>
          <ul>
            <li>·为车主保价卖出</li>
            <li>·没有中间商赚差价</li>
            <li>·快速卖车</li>
            <li>·大兴专业渠道，海量车商报价</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flex-center" style="position: fixed;height: 1.728rem;width: 100%;bottom: 0;background: #fff;">
      <div class="flex-center" style="background: #e9081a;color: #fff;font-size: .432rem;width: 90%;height: 1.188rem;border-radius: .594rem;" @click="toPublish">填写车辆信息</div>
    </div>

  </div>
</template>

<script>
    import {
        NavBar,
        Tag,
        Col,
        Icon,
        Cell,
        CellGroup,
        Swipe,
        Toast,
        SwipeItem,
        GoodsAction,
        GoodsActionIcon,
        GoodsActionButton
    } from 'vant';

    import index1 from '../../image/index1.png'; // import 引入图片
    import index2 from '../../image/index2.png';
    import index3 from '../../image/index3.png';
    import index4 from '../../image/index4.png';

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Tag.name]: Tag,
            [Col.name]: Col,
            [Icon.name]: Icon,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [GoodsAction.name]: GoodsAction,
            [GoodsActionIcon.name]: GoodsActionIcon,
            [GoodsActionButton.name]: GoodsActionButton
        },

        data() {
            return {
                goods: {
                    list:[
                        {name:"填写信息",icon:index1},
                        {name:"提交/审核",icon:index2},
                        {name:"平台售卖",icon:index3},
                        {name:"车辆交易",icon:index4}
                    ],
                    thumb: [
                        'https://img.yzcdn.cn/public_files/2017/10/24/e5a5a02309a41f9f5def56684808d9ae.jpeg',
                        'https://img.yzcdn.cn/public_files/2017/10/24/1791ba14088f9c2be8c610d0a6cc0f93.jpeg'
                    ]
                }
            };
        },

        methods: {
            onClickCars() {
                this.$router.push('Collect/Publish');
            },
            toPublish() {
                this.$router.push('SellCars/Publish');
            },
            onClickLeft() {
                this.$router.push('/SellCars');
            }
        }
    };
</script>

<style lang="less">
  .goods {
    padding-bottom: 50px;

    &-swipe {
      img {
        width: 100%;
        display: block;
      }
    }

    &-title {
      font-size: 16px;
    }

    &-price {
      color: #f44;
    }

    &-express {
      color: #999;
      font-size: 12px;
      padding: 5px 15px;
    }

    &-cell-group {
      margin: 15px 0;

      .van-cell__value {
        color: #999;
      }
    }

    &-tag {
      margin-left: 5px;
    }
  }

  body{
    background: #fff;
  }
  .flex-start{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:flex-start;
  }
  .flex-center{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:center;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .van-nav-bar__title{
    font-size: .486rem;
    color: #333;
  }
  .van-nav-bar .van-icon{
    font-size: .486rem;
    color: #333;
  }
</style>
